export const scheduleDialogHeader = "LAc";
export const scheduleCancelButton = "MAc";
export const returnToSuggestions = "NAc";
export default {scheduleDialogHeader,scheduleCancelButton,returnToSuggestions};